module.exports = __webpack_public_path__ + "img/contect.ba7d9ef0.jpg";